export default __webpack_public_path__ + "222c63abdc3b31a99e5dfaec2b6e3d55.png";